__turbopack_context__.v({
  "bigHeader": "Header-module__W-3Fya__bigHeader" + " " + "Header-module__W-3Fya__header",
  "header": "Header-module__W-3Fya__header",
  "hugeHeader": "Header-module__W-3Fya__hugeHeader" + " " + "Header-module__W-3Fya__header",
  "mediumHeader": "Header-module__W-3Fya__mediumHeader" + " " + "Header-module__W-3Fya__header",
  "semiBigHeader": "Header-module__W-3Fya__semiBigHeader" + " " + "Header-module__W-3Fya__header",
  "smallHeader": "Header-module__W-3Fya__smallHeader" + " " + "Header-module__W-3Fya__header",
});
